module.exports = __webpack_public_path__ + "media/images/logos/small-logo-21ec24099292e381c68b764ab9a1e163.png";